(function () {
  'use strict';

  var MAX_QUANTITY = 99;

  function refreshCart(added) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (added && added.sections) cart.sections = added.sections;
        try {
          if (window.FoxTheme && window.FoxTheme.pubsub && window.FoxTheme.pubsub.PUB_SUB_EVENTS) {
            window.FoxTheme.pubsub.publish(
              window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
              { cart: cart }
            );
          }
        } catch (error) {}

        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          try { drawer.show(); return; } catch (error) {}
        }
        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { open: true }
          }));
        } catch (error) {}
      })
      .catch(function () {
        /* The item was added; the inline confirmation remains the fallback. */
      });
  }

  function addItems(items) {
    var valid = (items || []).filter(function (item) {
      return item && parseInt(item.id, 10) > 0 && parseInt(item.quantity, 10) > 0;
    });
    if (!valid.length) return Promise.reject(new Error('No available powder bags were selected.'));

    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections: sections }
      }));
    } catch (error) {}

    var payload = { items: valid };
    if (sections.length) {
      payload.sections = sections.join(',');
      payload.sections_url = window.location.pathname;
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.text().then(function (text) {
          var data = null;
          try { data = JSON.parse(text); } catch (error) {}
          if (!response.ok) {
            throw new Error(
              (data && (data.description || data.message)) ||
              ('Could not add to cart (error ' + response.status + ').')
            );
          }
          return data;
        });
      })
      .then(function (data) {
        return refreshCart(data).then(function () { return data; });
      });
  }

  function initForm(form) {
    if (form.getAttribute('data-dcpw-wired') === 'true') return;
    form.setAttribute('data-dcpw-wired', 'true');

    var radios = form.querySelectorAll('input[name="id"]');
    var quantity = form.querySelector('input[name="quantity"]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    var price = form.querySelector('[data-powder-price]');
    var message = form.querySelector('[data-powder-message]');
    var submit = form.querySelector('.dcpw-atc');

    function selected() {
      for (var index = 0; index < radios.length; index += 1) {
        if (radios[index].checked && !radios[index].disabled) return radios[index];
      }
      return null;
    }

    function clampQuantity() {
      if (!quantity) return 1;
      var value = parseInt(quantity.value, 10);
      if (!Number.isFinite(value) || value < 1) value = 1;
      if (value > MAX_QUANTITY) value = MAX_QUANTITY;
      quantity.value = value;
      if (minus) minus.disabled = value <= 1;
      if (plus) plus.disabled = value >= MAX_QUANTITY;
      return value;
    }

    function say(copy, failed) {
      if (!message) return;
      message.textContent = copy || '';
      message.className = 'dcpw-buy__message' + (copy ? (failed ? ' is-error' : ' is-success') : '');
    }

    function sync() {
      var radio = selected();
      if (!radio) {
        if (price) price.textContent = '';
        if (submit) submit.disabled = true;
        return;
      }
      if (price) {
        price.innerHTML = '<b>' + (radio.getAttribute('data-price') || '') + '</b><span>per ' +
          (radio.getAttribute('data-size-label') || 'bag').toLowerCase() + '</span>';
      }
      if (submit) submit.disabled = false;
    }

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () { say(''); sync(); });
    });
    if (quantity) {
      quantity.addEventListener('input', clampQuantity);
      quantity.addEventListener('change', clampQuantity);
      quantity.addEventListener('blur', clampQuantity);
    }
    if (minus) minus.addEventListener('click', function () {
      quantity.value = Math.max(1, clampQuantity() - 1);
      clampQuantity();
    });
    if (plus) plus.addEventListener('click', function () {
      quantity.value = Math.min(MAX_QUANTITY, clampQuantity() + 1);
      clampQuantity();
    });

    clampQuantity();
    sync();

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var radio = selected();
      if (!radio) { say('Choose an available bag size.', true); return; }
      var variantId = parseInt(radio.value, 10);
      var count = clampQuantity();
      if (!variantId) { say('This bag size cannot be added right now.', true); return; }

      var original = submit ? submit.innerHTML : '';
      if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
      addItems([{ id: variantId, quantity: count }])
        .then(function () {
          if (submit) { submit.disabled = false; submit.innerHTML = original; }
          say('Added to cart: ' + count + ' × ' + radio.getAttribute('data-size-label') + '.', false);
        })
        .catch(function (error) {
          if (submit) { submit.disabled = false; submit.innerHTML = original; }
          say(error && error.message ? error.message : 'Could not add to cart. Try again.', true);
        });
    });
  }

  function init(scope) {
    var root = scope || document.getElementById('dcpowderpdp');
    if (!root) return;
    var forms = root.matches && root.matches('form.dcpw-buy') ? [root] : root.querySelectorAll('form.dcpw-buy');
    Array.prototype.forEach.call(forms, initForm);
  }

  window.DcPowderBuy = { init: init, addItems: addItems };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();